import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.665 2.65L17.51 18.99c-.238 1.075-.86 1.343-1.744.836l-4.818-3.55-2.325 2.238c-.257.257-.472.472-.968.472l.346-4.902 8.923-8.062c.388-.345-.084-.537-.603-.192L5.87 12.05l-4.33-1.354c-.942-.294-.96-.942.196-1.394L19.35.876c.784-.294 1.47.19 1.315 1.774z"
      ></path>
    </svg>
  );
}

export default Icon;
